// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2eJi6","form":"styles_form__gACK5"};